const pl_PL = {
  loading: "Ładowanie...",
  main_page_slogan_1: "Dołącz do naszego plemienia",
  main_page_slogan_2: "i eksploruj dżunglę komunikacji!",
  main_page_sign_in: "Zaloguj się",
  main_page_or: "Lub",
  main_page_create_account: "Stwórz profil",

  // Niebieski - Pierwsza Lista:

  blue_section_one_title: "Cechy i zachowanie",

  blue_subsection_one_title: "Motywy i główne cechy",
  blue_subsection_one_description_one: "precyzja",
  blue_subsection_one_description_two: "logika",
  blue_subsection_one_description_three: "pracowitość",
  blue_subsection_one_description_four: "dokładność",
  blue_subsection_one_description_five: "konsekwencja",
  blue_subsection_one_description_six: "systematyczność",
  blue_subsection_one_description_seven: "zadaje szczegółowe pytania",
  blue_subsection_one_description_eight: "zorganizowany",

  blue_subsection_two_title: "Zachowanie",
  blue_subsection_two_description_one: "zorientowany na procesy i analizę",
  blue_subsection_two_description_two: "introwertyk",

  blue_subsection_three_title: "Bywa odbierany jako",
  blue_subsection_three_description_one: "krytyczny",
  blue_subsection_three_description_two: "nieufny",

  // Niebieski - Druga Lista:

  blue_section_two_title: "Mowa ciała",

  blue_subsection_two_one_title: "Postawa",
  blue_subsection_two_one_description_one: "usztywniona",
  blue_subsection_two_one_description_two: "„zamknięta”",

  blue_subsection_two_two_title: "Chód",
  blue_subsection_two_two_description_one: "pewny",
  blue_subsection_two_two_description_two: "prosto do celu",

  blue_subsection_two_three_title: "Gesty",
  blue_subsection_two_three_description_one: "bardzo oszczędne i celowe",
  blue_subsection_two_three_description_two: "mało gestykuluje lub wcale",
  blue_subsection_two_three_description_three: "oszczędna mimika",
  blue_subsection_two_three_description_four: "nie okazuje emocji",

  blue_subsection_two_four_title: "Sposób mówienia",
  blue_subsection_two_four_description_one: "spokojny",
  blue_subsection_two_four_description_two: "rytmiczny",
  blue_subsection_two_four_description_three: "formalny",
  blue_subsection_two_four_description_four: "głos słabo modulowany",
  blue_subsection_two_four_description_five: "akcentuje rzeczy ważne dla niego",
  blue_subsection_two_four_description_six: "precyzyjne sformułowania",

  // Niebieski - Trzecia Lista:

  blue_section_three_title: "W stresie",

  blue_subsection_three_one_title: "Cel",
  blue_subsection_three_one_description_one: "uczciwość",
  blue_subsection_three_one_description_two: "racjonalne decyzje",
  blue_subsection_three_one_description_three: "precyzja",

  blue_subsection_three_two_title: "Nacisk na",
  blue_subsection_three_two_description_one: "powściągliwość",
  blue_subsection_three_two_description_two: "analizowanie",
  blue_subsection_three_two_description_three: "sztywność",

  blue_subsection_three_three_title: "Lęk przed",
  blue_subsection_three_three_description_one: "pomyłką",
  blue_subsection_three_three_description_two: "okazaniem silnych emocji",

  // Niebieski - Czwarta Lista:

  blue_section_four_title: "Wkład do zespołu",

  blue_subsection_four_one_description1_one: "samo zdyscyplinowany",
  blue_subsection_four_one_description2_two: "dobrze przygotowany",

  // Niebieski -  Piąta Lista:

  blue_section_five_title: "Styl komunikacji",

  blue_subsection_five_one_title: "Sposób komunikacji",
  blue_subsection_five_one_description_one: "bezpośredni",

  blue_subsection_five_two_title: "Jakie komunikaty odbierasz lepiej",
  blue_subsection_five_two_description_one: "naładowane informacjami",
  blue_subsection_five_two_description_two:
    "przekazywane precyzyjnie i spokojnie",
  blue_subsection_five_two_description_three: "obiektywne dane",
  blue_subsection_five_two_description_four: "kiedy rozmówca jest przygotowany",

  blue_subsection_five_three_title: "Jakich komunikatów nie lubisz?",
  blue_subsection_five_three_description_one: "chaotyczny",
  blue_subsection_five_three_description_two: "rozmowy „o niczym”",
  blue_subsection_five_three_description_three:
    "zbyt nieformalnych i poufałych",
  blue_subsection_five_three_description_four: "emocjnonalnych",

  // Niebieski - Szósta Lista:

  blue_section_six_title: "Komunikacja z innymi",

  blue_subsection_six_one_title:
    "Jak porozumiewać się z innymi? Kilka wskazówek dla niebieskich:",

  blue_subsection_six_two_title: "Niebieski - Czerwony",
  blue_subsection_six_two_description_one: "mów wprost",
  blue_subsection_six_two_description_two: "ponieś poziom ekspresji",
  blue_subsection_six_two_description_three: "bądź punktualny",
  blue_subsection_six_two_description_four: "koncentruj się na temacie i celu",
  blue_subsection_six_two_description_five: "formułuj krótkie wypowiedzi",
  blue_subsection_six_two_description_six:
    "nie unikaj konfrontacji, ale nie próbuj dominować",
  blue_subsection_six_two_description_seven:
    "nie opowiadaj o procesie, tylko o wynikach",
  blue_subsection_six_two_description_eight:
    "zaprezentuj parę opcji i wybór zostaw czerwonemu",
  blue_subsection_six_two_description_nine:
    "koncentruj się na zyskach, korzyściach i efektach",
  blue_subsection_six_two_description_ten:
    "nie odbieraj opinii czerwonego osobiście",

  blue_subsection_six_three_title: "Niebieski - Żółty",
  blue_subsection_six_three_description_one: "podnieś poziom ekspresji",
  blue_subsection_six_three_description_two:
    "poświęć energię na rozmowę towarzyską",
  blue_subsection_six_three_description_three: "okazuj emocje i uznanie",
  blue_subsection_six_three_description_four: "doceń dobrą zabawę",
  blue_subsection_six_three_description_five: "rozmawiaj o ludziach i emocjach",
  blue_subsection_six_three_description_six: "nie wywieraj presji",
  blue_subsection_six_three_description_seven: "nie ograniczaj procedurami",
  blue_subsection_six_three_description_eight:
    "postaraj się nawiązać osobisty kontakt",
  blue_subsection_six_three_description_nine: "zaakceptuj spóźnienia",
  blue_subsection_six_three_description_ten: "nie mów o zbyt wielu szczegółach",

  blue_subsection_six_four_title: "Niebieski - Niebieski",
  blue_subsection_six_four_description_one: "udzielaj wielu informacji",
  blue_subsection_six_four_description_two: "bądź przygotowany",

  blue_subsection_six_five_title: "Niebieski - Zielony",
  blue_subsection_six_five_description_one: "zadbaj o komfort i bezpieczeństwo",
  blue_subsection_six_five_description_two: "buduj zaufanie",
  blue_subsection_six_five_description_three: "koncentruj się na ludziach",
  blue_subsection_six_five_description_four: "okazuj empatię",
  blue_subsection_six_five_description_five:
    "nie próbuj dominować i narzucać swojego zdania",
  blue_subsection_six_five_description_six: "dotrzymuj słowa",
  blue_subsection_six_five_description_seven:
    "bądź wyrozumiały dla emocjonalnych rozterek",

  // Zielony - Pierwsza Lista:

  green_section_one_title: "Cechy i zachowanie",

  green_subsection_one_title: "Motywy i główne cechy",
  green_subsection_one_description_one: "spokój",
  green_subsection_one_description_two: "uprzejmość",
  green_subsection_one_description_three: "poświęcenie",
  green_subsection_one_description_four: "cierpliwość",
  green_subsection_one_description_five: "rodzinność",
  green_subsection_one_description_six: "empatia",
  green_subsection_one_description_seven: "bezpieczeństwo",
  green_subsection_one_description_eight: "tradycjonalizm",
  green_subsection_one_description_nine: "nieśmiałość",
  green_subsection_one_description_ten: "życzliwość",

  green_subsection_two_title: "Zachowanie",
  green_subsection_two_description_one: "zorientowany na ludzi i relacje",
  green_subsection_two_description_two: "introwertyk",

  green_subsection_three_title: "Bywa odbierany jako",
  green_subsection_three_description_one: "zaborczy",

  // Zielony - Druga Lista:

  green_section_two_title: "Mowa ciała",

  green_subsection_two_one_title: "Postawa",
  green_subsection_two_one_description_one: "lekko przygarbiona",
  green_subsection_two_one_description_two: "rozluźniona",

  green_subsection_two_two_title: "Chód",
  green_subsection_two_two_description_one: "niepewny",
  green_subsection_two_two_description_two: "krótki krok",
  green_subsection_two_two_description_three: "równe tempo",

  green_subsection_two_three_title: "Gesty",
  green_subsection_two_three_description_one: "powolne i łagodne",
  green_subsection_two_three_description_two: "oszczędne",
  green_subsection_two_three_description_three: "„poker face”",

  green_subsection_two_four_title: "Sposób mówienia",
  green_subsection_two_four_description_one: "głos ciepły i cichy",
  green_subsection_two_four_description_two: "lekka modulacja głosu",
  green_subsection_two_four_description_three: "mało akcentów",
  green_subsection_two_four_description_four:
    "z uprzejmości podąża za wątkiem rozmowy narzuconym przez rozmówcę",
  green_subsection_two_four_description_five: "chętniej słucha niż mówi",

  // Zielony - Trzecia Lista:

  green_section_three_title: "W stresie",

  green_subsection_three_one_title: "Cel",
  green_subsection_three_one_description_one: "porozumienie",
  green_subsection_three_one_description_two: "akceptacja",
  green_subsection_three_one_description_three: "spokój",

  green_subsection_three_two_title: "Nacisk na",
  green_subsection_three_two_description_one: "pasywny opór",
  green_subsection_three_two_description_two: "kompromis",

  green_subsection_three_three_title: "Lęk przed",
  green_subsection_three_three_description_one: "rozczarowaniem innych",
  green_subsection_three_three_description_two: "agresją",

  // Zielony - Czwarta Lista:

  green_section_four_title: "Wkład do zespołu",

  green_subsection_four_one_description1_one: "chęć niesienia pomocy",
  green_subsection_four_one_description2_two: "zorientowany na usługi",

  // Zielony - Piąta Lista:

  green_section_five_title: "Styl komunikacji",

  green_subsection_five_one_title: "Sposób komunikacji",
  green_subsection_five_one_description_one: "pośrednia",

  green_subsection_five_two_title: "Jakie komunikaty odbierasz lepiej",
  green_subsection_five_two_description_one: "metodyczne i spokojne",
  green_subsection_five_two_description_two: "nieformalne",
  green_subsection_five_two_description_three:
    "wychodzenie z inicjatywą przez innych - lepiej reagujesz na to co się zdarza, niż wychodząc z inicjatywą",
  green_subsection_five_two_description_four: "przewidywalny przebieg rozmowy",

  green_subsection_five_three_title: "Jakich komunikatów nie lubisz?",
  green_subsection_five_three_description_one: "zbyt oficjalnych",
  green_subsection_five_three_description_two: "poufałych",
  green_subsection_five_three_description_three: "zbyt wielu opcji do wyboru",
  green_subsection_five_three_description_four:
    "zmuszających do podjęcia decyzji „tu i teraz”",

  // Zielony - Szósta Lista:

  green_section_six_title: "Komunikacja z innymi",

  green_subsection_six_one_title:
    "Jak porozumiewać się z innymi? Kilka wskazówek dla zielonych:",

  green_subsection_six_two_title: "Zielony - Czerwony",
  green_subsection_six_two_description_one: "podnieś poziom ekspresji",
  green_subsection_six_two_description_two: "mów konkretnie",
  green_subsection_six_two_description_three:
    "prezentuj gotowe wyniki w formie opcji",
  green_subsection_six_two_description_four:
    "koncentruj się na celu, zyskach i korzyściach",
  green_subsection_six_two_description_five:
    "nie traktuj tego co słyszysz zbyt osobiście",
  green_subsection_six_two_description_six: "unikaj wahania",
  green_subsection_six_two_description_seven: "otwarcie prezentuj swoje zdanie",
  green_subsection_six_two_description_eight:
    "skup się na faktach, a nie uczuciach",

  green_subsection_six_three_title: "Zielony - Żółty",
  green_subsection_six_three_description_one: "podnieś poziom ekspresji",
  green_subsection_six_three_description_two: "pokaż zaangażowanie",
  green_subsection_six_three_description_three: "okaż więcej entuzjazmu",
  green_subsection_six_three_description_four:
    "nie koncentruj się na negatywnych kwestiach",
  green_subsection_six_three_description_five: "więcej mów",
  green_subsection_six_three_description_six:
    "koncentruj się na szerszym, ogólnym obrazie sytuacji",

  green_subsection_six_four_title: "Zielony - Niebieski",
  green_subsection_six_four_description_one:
    "mniej koncentruj się na uczuciach",
  green_subsection_six_four_description_two:
    "skup się na logicznej analizie procesu",
  green_subsection_six_four_description_three: "dąż do obiektywności",
  green_subsection_six_four_description_four: "bądź dokładny",
  green_subsection_six_four_description_five: "odwołuj się do źródeł i faktów",
  green_subsection_six_four_description_six:
    "nie upieraj się przy osobistych opiniach",
  green_subsection_six_four_description_seven:
    "staraj się być bardziej zdystansowany i formalny",
  green_subsection_six_four_description_eight:
    "przygotuj się na szczegółowe pytania",

  green_subsection_six_five_title: "Zielony - Zielony",
  green_subsection_six_five_description_one: "więcej mów",
  green_subsection_six_five_description_two: "okazuj życzliwość i cierpliwość",
  green_subsection_six_five_description_three: "doradzaj",
  green_subsection_six_five_description_four:
    "postaraj się być „cierpliwym konsultantem”",

  // Czerwony - Pierwsza Lista:

  red_section_one_title: "Cechy i zachowanie",

  red_subsection_one_title: "Motywy i główne cechy",
  red_subsection_one_description_one: "natychmiastowy wynik",
  red_subsection_one_description_two: "działanie",
  red_subsection_one_description_three: "pewność siebie",
  red_subsection_one_description_four: "bezpośredniość",
  red_subsection_one_description_five: "szczerość",
  red_subsection_one_description_six: "podejmowanie ryzyka",

  red_subsection_two_title: "Zachowanie",
  red_subsection_two_description_one: "zorientowany na wynik",
  red_subsection_two_description_two: "ekstrawertyk",

  red_subsection_three_title: "Bywa odbierany jako",
  red_subsection_three_description_one: "niecierpliwy",
  red_subsection_three_description_two: "agresywny",

  // Czerwony - Druga Lista:

  red_section_two_title: "Mowa ciała",

  red_subsection_two_one_title: "Postawa",
  red_subsection_two_one_description_one: "wyprostowana",
  red_subsection_two_one_description_two: "czasem usztywniona",

  red_subsection_two_two_title: "Chód",
  red_subsection_two_two_description_one: "szybki",

  red_subsection_two_three_title: "Gesty",
  red_subsection_two_three_description_one: "zdecydowane",
  red_subsection_two_three_description_two: "szybkie i gwałtowne",
  red_subsection_two_three_description_three: "dużo gestykuluje",
  red_subsection_two_three_description_four: "śmiało patrzy w oczy",
  red_subsection_two_three_description_five: "pewny uścisk dłoni",

  red_subsection_two_four_title: "Sposób mówienia",
  red_subsection_two_four_description_one: "głośno",
  red_subsection_two_four_description_two: "raczej szybko",
  red_subsection_two_four_description_three: "rytmicznie",
  red_subsection_two_four_description_four: "krótkie",
  red_subsection_two_four_description_five: "precyzyjne zdania",
  red_subsection_two_four_description_six: "głos słabo modulowany",

  // Czerwony - Trzecia Lista:

  red_section_three_title: "W stresie",

  red_subsection_three_one_title: "Cel",
  red_subsection_three_one_description_one: "zwycięstwo",
  red_subsection_three_one_description_two: "wynik",
  red_subsection_three_one_description_three: "wygrana to osobiste osiągnięcie",

  red_subsection_three_two_title: "Nacisk na",
  red_subsection_three_two_description_one: "wygraną za wszelką cenę",
  red_subsection_three_two_description_two: "bezpośredniość",
  red_subsection_three_two_description_three: "niecierpliwość",

  red_subsection_three_three_title: "Lęk przed",
  red_subsection_three_three_description_one: "wykorzystaniem",
  red_subsection_three_three_description_two: "byciem postrzeganym jako słaby",

  // Czerwony - Czwarta Lista:

  red_section_four_title: "Wkład do zespołu",

  red_subsection_four_one_description1_one: "dąży do celu",
  red_subsection_four_one_description2_two: "wysoki poziom aktywności",

  // Czerwony - Piąta Lista:

  red_section_five_title: "Styl komunikacji",

  red_subsection_five_one_title: "Sposób komunikacji",
  red_subsection_five_one_description_one: "bezpośredni",

  red_subsection_five_two_title: "Jakie komunikaty odbierasz najlepiej",
  red_subsection_five_two_description_one: "zorientowane na wynik",
  red_subsection_five_two_description_two: "krótkie i zwięzłe",
  red_subsection_five_two_description_three: "przekazywane pewnie",
  red_subsection_five_two_description_four: "szczere i bezpośrednie",
  red_subsection_five_two_description_five: "bez zbędnych emocji",

  red_subsection_five_three_title: "Jakich komunikatów nie lubisz?",
  red_subsection_five_three_description_one: "pogawędek",
  red_subsection_five_three_description_two: "zapewnień bez pokrycia",
  red_subsection_five_three_description_three: "wchodzących w zbędne szczegóły",
  red_subsection_five_three_description_four:
    "wielokrotnego tłumaczenia jednej sprawy",

  // Czerwony - Szósta Lista:

  red_section_six_title: "Komunikacja z innymi",

  red_subsection_six_one_title:
    "Jak porozumiewać się z innymi? Kilka wskazówek dla czerwonych:",

  red_subsection_six_two_title: "Czerwony - Czerwony",
  red_subsection_six_two_description_one: "nie bój się odważnych pomysłów",
  red_subsection_six_two_description_two: "słuchaj uważnie",
  red_subsection_six_two_description_three:
    "nie obiecuj czegoś, czego nie „dowieziesz”",
  red_subsection_six_two_description_four: "nie próbuj dominować",

  red_subsection_six_three_title: "Czerwony - Żółty",
  red_subsection_six_three_description_one:
    "najpierw luźna rozmowa – potem biznes",
  red_subsection_six_three_description_two: "zrezygnuj z formalizmu",
  red_subsection_six_three_description_three: "okazuj więcej entuzjazmu",
  red_subsection_six_three_description_four:
    "skup się na aspektach ludzkich i relacjach",
  red_subsection_six_three_description_five: "okazuj zaangażowanie",
  red_subsection_six_three_description_six: "nie ograniczaj kreatywności",

  red_subsection_six_four_title: "Czerwony - Niebieski",
  red_subsection_six_four_description_one: "zwolnij i obniż ekspresję",
  red_subsection_six_four_description_two: "bądź cierpliwy",
  red_subsection_six_four_description_three:
    "zaakceptuj dużą ilość informacji i analiz",
  red_subsection_six_four_description_four: "udzielaj szczegółowych odpowiedzi",
  red_subsection_six_four_description_five: "doceń merytorykę",
  red_subsection_six_four_description_six: "nie bagatelizuj",
  red_subsection_six_four_description_seven: "spokojnie odpowiadaj na pytania",
  red_subsection_six_four_description_eight: "nie wywieraj presji",
  red_subsection_six_four_description_nine:
    "daj czas na przemyślenie i podjęcie decyzji",

  red_subsection_six_five_title: "Czerwony - Zielony",
  red_subsection_six_five_description_one: "okaż troskę o ludzi i relacje",
  red_subsection_six_five_description_two: "bądź mniej bezpośredni",
  red_subsection_six_five_description_three:
    "nie dominuj i nie narzucaj swojego zdania",
  red_subsection_six_five_description_four: "zadawaj pytania",
  red_subsection_six_five_description_five: "ale nie przesłuchuj",
  red_subsection_six_five_description_six: "emocje traktuj jak informacje",
  red_subsection_six_five_description_seven: "bądź empatyczny",
  red_subsection_six_five_description_eight:
    "nie wymuszaj natychmiastowej odpowiedzi",

  // Żółty - Pierwsza Lista:

  yellow_section_one_title: "Cechy i zachowanie",

  yellow_subsection_one_title: "Motywy i główne cechy",
  yellow_subsection_one_description_one: "zaufanie",
  yellow_subsection_one_description_two: "optymizm",
  yellow_subsection_one_description_three: "humor",
  yellow_subsection_one_description_four: "kreatywność",
  yellow_subsection_one_description_five: "spontaniczność",
  yellow_subsection_one_description_six: "działanie",
  yellow_subsection_one_description_seven: "relacje",
  yellow_subsection_one_description_eight: "przygoda",
  yellow_subsection_one_description_nine: "szybko się nudzi",

  yellow_subsection_two_title: "Zachowanie",
  yellow_subsection_two_description_one: "zorientowany na przeżycia i doznania",
  yellow_subsection_two_description_two: "ekstrawertyk",

  yellow_subsection_three_title: "Bywa odbierany jako",
  yellow_subsection_three_description_one: "chaotyczny",

  // Żółty - Druga Lista:

  yellow_section_two_title: "Mowa ciała",

  yellow_subsection_two_one_title: "Postawa",
  yellow_subsection_two_one_description_one: "wyprostowana",
  yellow_subsection_two_one_description_two: "rozluźniona",
  yellow_subsection_two_one_description_three: "ruchy swobodne",

  yellow_subsection_two_two_title: "Chód",
  yellow_subsection_two_two_description_one: "swobodny",
  yellow_subsection_two_two_description_two: "dynamiczny",

  yellow_subsection_two_three_title: "Gesty",
  yellow_subsection_two_three_description_one: "swobodne",
  yellow_subsection_two_three_description_two: "bogata mimika",
  yellow_subsection_two_three_description_three: "dużo gestykuluje",

  yellow_subsection_two_four_title: "Sposób mówienia",
  yellow_subsection_two_four_description_one: "przyjazny",
  yellow_subsection_two_four_description_two:
    "całym ciałem podkreśla to co mówi",
  yellow_subsection_two_four_description_three: "głośno i szybko",
  yellow_subsection_two_four_description_four: "bogata modulacja",
  yellow_subsection_two_four_description_five: "zróżnicowane słownictwo",
  yellow_subsection_two_four_description_six: "często zbacza z tematu",

  // Żółty - Trzecia Lista:

  yellow_section_three_title: "W stresie",

  yellow_subsection_three_one_title: "Cel",
  yellow_subsection_three_one_description_one: "aprobata",
  yellow_subsection_three_one_description_two: "zrozumienie",
  yellow_subsection_three_one_description_three: "otwartość",

  yellow_subsection_three_two_title: "Nacisk na",
  yellow_subsection_three_two_description_one: "pasja",
  yellow_subsection_three_two_description_two: "impulsywność",
  yellow_subsection_three_two_description_three: "szczerość",

  yellow_subsection_three_three_title: "Lęk przed",
  yellow_subsection_three_three_description_one: "odrzuceniem",
  yellow_subsection_three_three_description_two: "brakiem aprobaty",

  // Żółty - Czwarta Lista:

  yellow_section_four_title: "Wkład do zespołu",

  yellow_subsection_four_one_description1_one: "promuje idee",
  yellow_subsection_four_one_description2_two: "osiąga rezultaty przez ludzi",

  // Żółty - Piąta Lista:

  yellow_section_five_title: "Styl komunikacji",

  yellow_subsection_five_one_title: "Sposób komunikacji",
  yellow_subsection_five_one_description_one: "pośrednia",

  yellow_subsection_five_two_title: "Jakie komunikaty odbierasz lepiej",
  yellow_subsection_five_two_description_one: "luźne i swobodne",
  yellow_subsection_five_two_description_two: "pełne humoru",
  yellow_subsection_five_two_description_three: "rozmowy o wszystkim",
  yellow_subsection_five_two_description_four: "nie tylko o biznesie",

  yellow_subsection_five_three_title: "Jakich komunikatów nie lubisz?",
  yellow_subsection_five_three_description_one: "“zimnych”",
  yellow_subsection_five_three_description_two: "zbyt oficjalny",
  yellow_subsection_five_three_description_three:
    "skupianie się na szczegółach",
  yellow_subsection_five_three_description_four: "okazywanie zniecierpliwienia",
  yellow_subsection_five_three_description_five: "bądź znudzenia tematem",
  yellow_subsection_five_three_description_six: "brak elastyczności",
  yellow_subsection_five_three_description_seven:
    "wypominanie braku zorganizowania",

  // Żółty - Szósta Lista:

  yellow_section_six_title: "Komunikacja z innymi",

  yellow_subsection_six_one_title:
    "Jak porozumiewać się z innymi? Kilka wskazówek dla żółtych:",

  yellow_subsection_six_two_title: "Żółty - Czerwony",
  yellow_subsection_six_two_description_one: "od razu przechodź do rzeczy",
  yellow_subsection_six_two_description_two:
    "najpierw biznes – potem luźna rozmowa",
  yellow_subsection_six_two_description_three: "mów konkretnie",
  yellow_subsection_six_two_description_four:
    "zawężaj opcje wyboru do 2-3 propozycji",
  yellow_subsection_six_two_description_five: "stonuj emocje",
  yellow_subsection_six_two_description_six: "nie próbuj dominować",
  yellow_subsection_six_two_description_seven:
    "pozwól czerwonemu podjąć decyzję",
  yellow_subsection_six_two_description_eight:
    "nie trać wątku (i nie zmieniaj go)",
  yellow_subsection_six_two_description_nine:
    "konkretnie i stanowczo prezentuj swoje stanowisko",
  yellow_subsection_six_two_description_ten: "bądź punktualny i skupiony",

  yellow_subsection_six_three_title: "Żółty - Żółty",
  yellow_subsection_six_three_description_one: "daj się wygadać",
  yellow_subsection_six_three_description_two: "okazuj atencję",

  yellow_subsection_six_four_title: "Żółty - Niebieski",
  yellow_subsection_six_four_description_one: "obniż poziom ekspresji",
  yellow_subsection_six_four_description_two: "stonuj emocje",
  yellow_subsection_six_four_description_three:
    "wypowiedzi konstruuj bardziej linearnie (wstęp, rozwinięcie, zakończenie)",
  yellow_subsection_six_four_description_four: "nie idź na żywioł",
  yellow_subsection_six_four_description_five:
    "zademonstruj merytoryczne przygotowanie",
  yellow_subsection_six_four_description_six:
    "spróbuj koncentrować się na szczegółach",
  yellow_subsection_six_four_description_seven: "bądź cierpliwy, zwolnij",
  yellow_subsection_six_four_description_eight: "skoncentruj się na temacie",
  yellow_subsection_six_four_description_nine: "unikaj kontaktu fizycznego",
  yellow_subsection_six_four_description_ten:
    "nie lekceważ poruszanych zagadnień",

  yellow_subsection_six_five_title: "Żółty - Zielony",
  yellow_subsection_six_five_description_one: "więcej słuchaj",
  yellow_subsection_six_five_description_two: "okazuj wsparcie",
  yellow_subsection_six_five_description_three: "buduj zaufanie",
  yellow_subsection_six_five_description_four:
    "zwolnij i obniż poziom ekspresji",
  yellow_subsection_six_five_description_five:
    "daj czas na przetrawienie emocji",
  yellow_subsection_six_five_description_six: "nie zaskakuj",
  yellow_subsection_six_five_description_seven: "bądź szczery i delikatny",
  yellow_subsection_six_five_description_eight:
    "nie wykorzystuj uległości swojego rozmówcy",
  yellow_subsection_six_five_description_nine:
    "spokojnie dopytuj o opinie i odczucia",

  // Errors:
  error_Email_Not_Exist: "Brak adresu w bazie",
  error_Email_Badly_Formatted: "Błędny adres email",
  error_Invalid_Password: "Błędne hasło",
  error_Invalid_Length_Of_Password: "Niepoprawna długość hasła",
  error_Passwords_Do_Not_Matches: "Wpisane hasła różnią się",
  error_User_Already_In_Use: "Adres email jest już w użyciu",
  error_Agreemnt_Not_Checked:
    "Nie zaakceptowano regulaminu i polityki prywatności",
  error_Too_Many_Request:
    "Zbyt dużo razy wpisano złe hasło, spróbuj później lub je zresetuj",
  error_Empty_Name_Message_Box: "To pole nie może być puste",
  error_Empty_Message_Box: "To pole nie może być puste",

  // ListItem:
  list_title_SelectedLanguage: "Wybrany język to",
  list_title_ApplicationLanguage: "Język aplikacji",
  list_title_AboutLoriini: "O aplikacji Loriini",
  list_title_Agreement: "Regulamin",
  list_title_PrivatePolicy: "Polityka prywatności",

  // NavigationAboutColorsBox.js:
  red_title_AboutColorsBox: "Czerwony",
  yellow_title_AboutColorsBox: "Żółty",
  blue_title_AboutColorsBox: "Niebieski",
  green_title_AboutColorsBox: "Zielony",

  //AboutColor - Quotations:
  red_quotation: "“Bring your pretty face to my axe!”",
  yellow_quotation:
    "“You like me because I’m a scoundrel. There aren’t enough scoundrels in your life.”",
  blue_quotation:
    "“I hate warriors, too narrow-minded. I’ll tell you what I do like though: a killer, a dyed-in-the-wool killer. Cold blooded, clean, methodical and thorough.”",
  green_quotation:
    "“Our differences are only skin deep, but our sames go down to the bone.”",

  // AboutLoriiniApp - Settings:
  about_LoriiniApp_title: "O Aplikacji Loriini",
  about_LoriiniApp_slogan_one: "powered by passion",
  about_LoriiniApp_slogan_two: "made for you with <3",
  about_LoriiniApp_button: "Napisz do nas",

  // Contact - Settings:
  contact_write_to_us_title: "Napisz do nas!",
  contact_your_name_field: "Twoje imię",
  contact_write_a_message_field: "Wpisz wiadomość",
  contact_send_button: "Wyślij",
  contact_cancel_button: "Anuluj",

  // ContactThankYou - Settings:
  contact_thank_you_thanks_title: "Dziękujemy!",
  contact_thank_you_message_sent: "Wiadomość została wysłana!",

  // EditProfilePage - Settings:
  editProfilePage_deleteAccount_message:
    "Kliknij OK jeżeli jesteś pewien, że chcesz usunąć konto",
  editProfilePage_deleteAccount_else_message_one:
    "Czy jesteś pewien, że chcesz usunąć konto?",
  editProfilePage_deleteAccount_else_message_two:
    "Twoje konto zostanie bezpowrotnie usunięte.",
  editProfilePage_deleteAccount_choices_no: "Nie",
  editProfilePage_deleteAccount_choices_yes: "Tak",
  editProfilePage_editProfile_title: "Edytuj Profil",
  editProfilePage_editProfile_change_password: "Zmień hasło",
  editProfilePage_editProfile_old_password: "wpisz stare hasło",
  editProfilePage_editProfile_new_password: "twoje nowe hasło",
  editProfilePage_editProfile_repeat_new_password: "powtórz nowe hasło",
  editProfilePage_editProfile_save_changes_button: "Zapisz zmiany",
  editProfilePage_editProfile_remove_account_button: "Usuń konto",

  editProfilePage_passwordChanged_message: "Hasło zostało zmienione.",

  //EditProfilePage - saga.js:
  removeAccount_verification_message:
    "Aby usunąć konto zaloguj się ponownie. W celu weryfikacji usunięcia konta, wymagane jest ponowna autoryzacja. Zaloguj się a następnie przejdź ponownie do ustawień aby usunąć konto.",
  removeAccount_sign_in_for_remove_message_one:
    "Aby usunąć konto zaloguj się ponownie.",
  removeAccount_sign_in_for_remove_message_two:
    "W celu weryfikacji usunięcia konta, wymagane jest ponowna autoryzacja. Zaloguj się a następnie przejdź ponownie do ustawień aby usunąć konto.",
  removeAccount_choices_cancel: "Anuluj",
  removeAccount_choices_okay: "Ok",
  removeAccount_accountDeleted_message:
    "Twoje konto zostało usunięte. Jest nam niezmiernie przykro, że nas opuszczasz, zostaniesz przekierowany do strony logowania.",
  removeAccount_accountDeleted_else_message_one:
    "Twoje konto zostało usunięte.",
  removeAccount_accountDeleted_else_message_two:
    "Jest nam niezmiernie przykro, że nas opuszczasz, zostaniesz przekierowany do strony logowania.",
  removeAccount_accountDeleted_text: "OK",

  // routes.js
  routes_KnowladgeManipulation: "Czym jest manipulacja?",
  routes_KnowladgeEffectiveCommunication: "O skutecznej komunikacji",
  routes_KnowladgeWaysOfCommunication: "Sposoby komunikacji",
  routes_KnowladgeWhatIsLoriiniTest: "Czy jest test Loriini?",
  routes_KnowladgeHowInterprateResult: "Jak interpretować wynik?",
  routes_KnowladgeColorTheory: "Teoria kolorów",
  routes_GreenAboutColorsPage: "O Zielonej Papudze",
  routes_YellowAboutColorsPage: "O Żółtej Papudze",
  routes_RedAboutColorsPage: "O Czerwonej Papudze",
  routes_BlueAboutColorsPage: "O Niebieskiej Papudze",
  routes_AboutLoriiniApp: "O Aplikacji",
  routes_EditProfilePage: "Edytuj Profil",
  routes_Start: "Back",
  routes_Privacy: "Privacy-Policy",
  routes_Cookies: "Cookies-Policy",
  routes_Agreement: "Agreement",
  routes_RegistrationForm: "RegistrationForm",
  routes_ForgotPassword: "ForgotPassword",
  routes_SendMessageReset: "SendMessageReset",
  routes_SignOut: "SignOut",
  routes_SignIn: "SignIn",
  routes_LoriiniTest: "LoriiniTest",
  routes_ContactThankYou: "Kontakt - Dziękujemy",
  routes_Contact: "Kontakt",
  routes_ModalTest: "ModalTest",
  routes_DeleteAccount: "DeleteAccount",
  routes_Settings: "Info",
  routes_Colors: "Colors",
  routes_User: "User",
  routes_TestLoriini: "TestLoriini",
  routes_Home: "Home",
  routes_ApplicationLanguage: "Język aplikacji",

  // YellowAboutColorsPageRoute.js
  routes_YellowAboutColorsPageRoute_autorName: "Han Solo, Star Wars",
  routes_YellowAboutColorsPageRoute_title: "Żółty - Inspirujący",

  // RedAboutColorsPageRoute.js
  routes_RedAboutColorsPageRoute_autorName: "Gimli, Lord of The Rings",
  routes_RedAboutColorsPageRoute_title: "Czerwony - Dominujący",

  // GreenAboutColorsPageRoute.js
  routes_GreenAboutColorsPageRoute_autorName: "Marge, The Simpsons",
  routes_GreenAboutColorsPageRoute_title: "Zielony - Stabilny",

  // BlueAboutColorsPageRoute.js
  routes_BlueAboutColorsPageRoute_autorName: "Zorg, The Fifth Element",
  routes_BlueAboutColorsPageRoute_title: "Niebieski - Analityczny",

  // HomeRoute.js
  homeRoute_welcome: "Witaj",
  homeRoute_textDescription: "Rozwiąż test i poznaj swój kolor",
  homeRoute_button2: "Rozwiąż test",
  homeRoute_showResult: "Zobacz pełny wynik",
  homeRoute_repeatTest: "Powtórz test",
  homeRoute_howInterprateResult: "Jak interpretować wynik?",
  homeRoute_whatIsLoriiniTest: "Czym jest test Loriini? - korzyści",
  homeRoute_colorsTheory: "Teoria kolorów - o co chodzi?",

  // Header
  header_title: "Loriini Tribes",
  header_subtitle: "Wszystkie odcienie osobowości",

  // WelcomeTest
  welcomeTest_hello: "Witaj",
  welcome_secondLine: "Nasz test to",
  welcome_thirdLine: "18 stwierdzeń",
  welcome_forthLine: "odnoszących się do życia zawodowego.",

  welcome_description_part1: "Zaznacz",
  welcome_description_part2: "odpowiedź",
  welcome_description_part3: "którą zgadzasz się bardziej i w jakim stopniu.",

  welcome_description2_part1: "Rozwiązanie testu nie powinno zająć więcej niż",
  welcome_description2_part2: " kilka minut ",
  welcome_description2_part3: "- kieruj się",
  welcome_description2_part4: "  pierwszym odczuciem",
  welcome_description2_part5: "zamiast długo rozmyślać nad odpowiedzią.",

  welcome_button: "ZACZYNAMY",

  // SliderBox
  sliderBox_dataSliderBox_1_title: "O skutecznej komunikacji",
  sliderBox_dataSliderBox_2_title: "Manipulacja a wywieranie wpływu",
  sliderBox_dataSliderBox_3_title: "Sposoby komunikacji",

  sliderBox_colorsDataBox_1: "Żółty",
  sliderBox_colorsDataBox_2: "Niebieski",
  sliderBox_colorsDataBox_3: "Czerwony",
  sliderBox_colorsDataBox_4: "Zielony",

  sliderBox_data_title_1: "O komunikacji",
  sliderBox_data_title_2: "Poznaj nasze kolory",

  // SingleTest
  singleTest_title: "PYTANIE",
  singleTest_of: "Z",
  singleTest_button: "DALEJ",

  // Settings
  settings_title: "Ustawienia",
  settings_logOut: "Wyloguj się",
  settings_editProfile: "edytuj profil",
  settings_slogan: "powered by passion, made for you with",

  // Results
  results_blue_red: "Niebiesko - Czerwony",
  results_blue_yellow: "Niebiesko - Żółty",
  results_blue_green: "Niebiesko - Zielony",
  results_red_blue: "Czerwono - Niebieski",
  results_red_yellow: "Czerwono - Żółty",
  results_red_green: "Czerwono - Zielony",
  results_yellow_blue: "Żółto - Niebieski",
  results_yellow_red: "Żółto - Czerwony",
  results_yellow_green: "Żółto - Zielony",
  results_green_red: "Zielono - Czerwony",
  results_green_blue: "Zielono - Niebieski",
  results_green_yellow: "Zielono - Żółty",

  results_title: "Twój kolor:",
  results_more: "Dowiedz się jak odczytać wynik",
  results_repeat: "Powtórz test",
  result_no_results_1: "Jeszcze nic tu nie ma.",
  result_no_results_2: "Rozwiąż test i poznaj swój kolor!",
  result_do_test: "Rozwiąż test",
  result_more_about_test: "Dowiedz się więcej o teście",

  // ResetSendMessage
  resetSendMessage_title: "WYSŁANE!",
  resetSendMessage_headermessage: "Na podany adres e-mail wysłaliśmy",
  resetSendMessage_headermessagetwo: "link do resetu hasła.",
  resetSendMessage_headertwomessage: "Sprawdź swoją pocztę i zaloguj się",
  resetSendMessage_headerlastmessage: "ponownie.",
  resetSendMessage_button_ok: "OK!",

  // Registration form
  registrationForm_title: "Zarejestruj się",
  registrationForm_e_mail: "e-mail",
  registrationForm_password: "hasło",
  registrationForm_repeat_password: "powtórz hasło",
  registrationForm_agree: "Akceptuję",
  registrationForm_agrement: "regulamin",
  registartionForm_and: " i ",
  registrationForm_privacy_policy: "politykę prywatności",
  registartionForm_create_a_profile: "Stwórz profil",
  registartionFrom_do_you_have_a_profile: "Masz już konto?",
  registartionForm_sign_in: "Zaloguj się",

  // login
  login_do_you_have_a_profie: "Nie masz jeszcze konta?",
  login_create_account: "Stwórz profil",
  login_forgot_passowrd: "Nie pamiętam hasła",
  login_forgot_e_mail: "e-mail",
  login_forgot_password: "hasło",
  login_signin: "Zaloguj się",

  // forgot password
  forgotPassword_title: "PRZYPOMNIJ HASŁO",
  forgotPassword_forgotmessage: "Podaj swój adres email w celu",
  forgotPassword_forgotmessagetwo: "zresetowania hasła",
  forgotPassword_email: "e-mail",
  forgotPassword_send: "Wyślij",
  forgotPassword_askbox: "Nie masz jeszcze konta?",
  forgotPassword_create_profile: "Stwórz profil",

  // DominateColor
  dominateColor_main: "Kolor Główny",
  dominateColor_complementary: "Kolor Uzupełniający",
  dominateColor_colors_red: "Czerwony",
  dominateColor_colors_blue: "Niebieski",
  dominateColor_colors_yellow: "Żółty",
  dominateColor_colors_green: "Zielony",

  // FooterMenu
  footerMenu_routes0_home: "Home",
  footerMenu_routes1_your_color: "Twój kolor",
  footerMenu_routes2_colors: "Kolory",

  // AboutColors
  aboutColors_title: "O kolorach",

  //Images - same of all colors
  team_image: require("../../assets/ZESPOL.png"),
  communication_image: require("../../assets/KOMUNIKACJA.png"),

  //Images - Charts - yellow.js
  yellow_chart: require("../../assets/new_charts/zolty_normal.png"),
  yellowInStress_chart: require("../../assets/new_charts/zolty_stres.png"),

  //Images - Charts - blue.js
  blue_chart: require("../../assets/new_charts/niebieski_normal.png"),
  blueInStress_chart: require("../../assets/new_charts/niebieski_stres.png"),

  //Images - Charts - green.js
  green_chart: require("../../assets/new_charts/zielony_normal.png"),
  greenInStress_chart: require("../../assets/new_charts/zielony_stres.png"),

  //Images - Charts - red.js
  red_chart: require("../../assets/new_charts/czerwony_normal.png"),
  redInStress_chart: require("../../assets/new_charts/czerwony_stres.png"),
};

export default pl_PL;
